import React, { useEffect } from "react";
import { useFormContext} from "react-hook-form";
import { addAcceptJsScript, removeAcceptJsScript, getNonceForCard, IAcceptJsResponse, getCardTypeForNumber } from "./SubscriptionForm";
import { ErrorMessage } from '@hookform/error-message';

export const PaymentCardEntry = () => {
 const { register, watch, formState, getValues, setValue } = useFormContext();
  useEffect(() => {
    addAcceptJsScript();
    return removeAcceptJsScript; //Pass unsubscribe function to remove script when unmounted
  }, []); //Run once upon mount
  watch(["cardExpMonth", "cardExpYear", "cardNumber", "cardSecurityCode"]);
  useEffect(() => {
    if(getValues().cardExpYear?.length == 4){
      setValue("cardExpYear", getValues().cardExpYear.slice(2,4));
    }
  }, [watch("cardExpYear")]);
   return (
    <React.Fragment>
      <fieldset disabled={formState.isSubmitting}>
        <legend className="block text-sm font-medium text-gray-700">Card Details</legend>
        <div className="mt-1 bg-white rounded-md shadow-sm -space-y-px">
          <div>
            <label htmlFor="card-number" className="sr-only">
              Card number
            </label>
            <input
              type="text"
              {...register("cardNumber", { minLength: 16, maxLength: 20 })}
              id="card-number"
              className="focus:ring-indigo-500 focus:border-indigo-500 relative block w-full rounded-none rounded-t-md bg-transparent focus:z-10 sm:text-sm border-gray-300"
              placeholder="Card number" />
            <ErrorMessage name={"cardNumber"} render={({ message }) => <p className="mt-2 text-sm text-red-600" >{message ? message : "Error"}</p>} />
          </div>
          <div className="flex -space-x-px">
            <div className="w-1/2 flex-1 min-w-0">
              <label htmlFor="card-expiration-date" className="sr-only">
                Expiration date
              </label>
              <input
                type="text"
                title="Card expiration month"
                {...register("cardExpMonth", { minLength: 1, maxLength: 2, min: 1, max: 12 })}
                id="card-expiration-month"
                className="focus:ring-indigo-500 focus:border-indigo-500 relative block w-full rounded-none rounded-bl-md bg-transparent focus:z-10 sm:text-sm border-gray-300"
                placeholder="MM" />
              <ErrorMessage name={"cardExpMonth"} render={({ message }) => <p className="mt-2 text-sm text-red-600" >{message ? message : "Error"}</p>} />
            </div>
            <div className="flex-1 min-w-0">
              <input
                type="text"
                {...register("cardExpYear", { minLength: 2, maxLength: 2, min: 21, max: 99 })}
                id="card-expiration-year"
                className="focus:ring-indigo-500 focus:border-indigo-500 relative block w-full rounded-none bg-transparent focus:z-10 sm:text-sm border-gray-300"
                placeholder="YY" />
              <ErrorMessage name={"cardExpYear"} render={({ message }) => <p className="mt-2 text-sm text-red-600" >{message ? message : "Error"}</p>} />
            </div>
            <div className="flex-1 min-w-0">
              <label htmlFor="card-cvc" className="sr-only">
                CVC
              </label>
              <input
                type="text"
                {...register("cardSecurityCode", {
                  minLength: {
                    message: "Card Security Code should be at least 3 numbers",
                    value: 3
                  }, maxLength: {
                    message: "Card Security Code should be at most 5 numbers",
                    value: 5
                  }
                })}
                id="card-cvc"
                autoComplete="cc-csc"
                className="focus:ring-indigo-500 focus:border-indigo-500 relative block w-full rounded-none rounded-br-md bg-transparent focus:z-10 sm:text-sm border-gray-300"
                placeholder="CVC" />
              <ErrorMessage name={"cardSecurityCode"} render={({ message }) => <p className="mt-2 text-sm text-red-600" >{message ? message : "Error"}</p>} />
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset  disabled={formState.isSubmitting} className="mt-6 bg-white">
        <legend className="block text-sm font-medium text-gray-700">Card Address</legend>
        <div className="mt-1 rounded-md shadow-sm -space-y-px">
          <div>
            <label htmlFor="country" className="sr-only">
              Country
            </label>
            <select
              id="country"
              {...register("cardCountry")}
              autoComplete="country-name"
              className="focus:ring-indigo-500 focus:border-indigo-500 relative block w-full rounded-none rounded-t-md bg-transparent focus:z-10 sm:text-sm border-gray-300"
            >
              <option>United States</option>
              <option>Canada</option>
              <option>Mexico</option>
            </select>
          </div>
          <div>
            <label htmlFor="postal-code" className="sr-only">
              ZIP / Postal code
            </label>
            <input
              type="text"
              {...register("cardZip", {
                maxLength: {
                  message: "Maximum 9-digit zip code",
                  value: 10
                }, minLength: {
                  message: "Minimum 5-digit zip code",
                  value: 5
                }
              })}
              id="postal-code"
              autoComplete="postal-code"
              className="focus:ring-indigo-500 focus:border-indigo-500 relative block w-full rounded-none rounded-b-md bg-transparent focus:z-10 sm:text-sm border-gray-300"
              placeholder="ZIP / Postal code" />
            <ErrorMessage name={"cardZip"} render={({ message,
            }) => <p className="mt-2 text-sm text-red-600" >{message ? message : "Error"}</p>} />
          </div>
        </div>
      </fieldset>
    </React.Fragment>
  );
};
/*<div className="mt-4 w-full content-center">
        {paymentNonce ? null : (<button onClick={() => handleUseThisCard()} type="button" title={!cardFieldsDirtied ? "You must fill out the credit card form before clicking this button" : "Securely save this card for payment of your subscription"} className={`inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white  ${cardFieldsDirtied ? " bg-yellow-600 hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500" : "cursor-not-allowed bg-gray-400"}`} disabled={!cardFieldsDirtied}>Use this card</button>)}
      </div>*/